export default {
  isochrones: {
    isochrones: 'Isochrones',
    isochronesReady: 'Isochrones ready',
    calculatingIsochrones: 'Calculating isochrones ...',
    itWasNotPossibleToCalculateIsochronesWithTheDefinedOptions: 'It was not possible to calculate isochrones with the defined options. Try to define smaller isochrone(s).',
    couldResolveTheSelectedPlaceAsASuitableCenter: 'It was not possible to resolve the selected point as a suitable center.',
    apiError: {
      2003: 'The area of a polygon to avoid must not exceed 20.0000 square kilometers.',
      3001: 'One or more parameters have an incorrect value or format.',
      3004: 'The combination of profile, interval and time or distance selected exceeds the maximum supported. Please adjust the values.',
      3099: 'Unable to build an isochrone map for the selected point(s) and profile.',
      3003: 'Parameter \'avoid_features\' has incorrect value of \'null\''
    },
    genericErrorMsg: 'It was not possible to calculate the isochrones.',
    timeoutError: 'The request took too long and timed out. Try smaller ranges or intervals.'
  }
}
